import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
  },
  secondaryColor: {
    color: '#371777',
  },
  button: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    borderRadius: 40,
    backgroundColor: '#7833FF',

    '&:hover': {
      backgroundColor: '#5F29CC',
    },
  },
  sectionImage: {
    display: 'block',
    margin: '0 auto',
    maxWidth: '100%',
  },
  title: {
    color: '#7833FF',
    fontSize: 28,
    fontFamily: 'Lato',
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4),
  },
  sectionImageGraphicalAbstract: {
    [theme.breakpoints.up('md')]: {
      height: 400,
    },
  },
}));
